<template>
  <svg
    width="50"
    height="44"
    viewBox="0 0 50 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.25"
      y="0.25"
      width="49.5"
      height="43.5"
      rx="7.75"
      stroke="#B7C3CD"
      stroke-width="0.5"
    />
    <path
      d="M22 25.75C22 25.5511 22.079 25.3603 22.2197 25.2197C22.3603 25.079 22.5511 25 22.75 25H27.25C27.4489 25 27.6397 25.079 27.7803 25.2197C27.921 25.3603 28 25.5511 28 25.75C28 25.9489 27.921 26.1397 27.7803 26.2803C27.6397 26.421 27.4489 26.5 27.25 26.5H22.75C22.5511 26.5 22.3603 26.421 22.2197 26.2803C22.079 26.1397 22 25.9489 22 25.75ZM19 21.25C19 21.0511 19.079 20.8603 19.2197 20.7197C19.3603 20.579 19.5511 20.5 19.75 20.5H30.25C30.4489 20.5 30.6397 20.579 30.7803 20.7197C30.921 20.8603 31 21.0511 31 21.25C31 21.4489 30.921 21.6397 30.7803 21.7803C30.6397 21.921 30.4489 22 30.25 22H19.75C19.5511 22 19.3603 21.921 19.2197 21.7803C19.079 21.6397 19 21.4489 19 21.25ZM16 16.75C16 16.5511 16.079 16.3603 16.2197 16.2197C16.3603 16.079 16.5511 16 16.75 16H33.25C33.4489 16 33.6397 16.079 33.7803 16.2197C33.921 16.3603 34 16.5511 34 16.75C34 16.9489 33.921 17.1397 33.7803 17.2803C33.6397 17.421 33.4489 17.5 33.25 17.5H16.75C16.5511 17.5 16.3603 17.421 16.2197 17.2803C16.079 17.1397 16 16.9489 16 16.75Z"
      fill="#B7C3CD"
    />
  </svg>
</template>

<script>
export default {
  name: "IconFilter",
};
</script>

<style></style>
